module.exports = __webpack_public_path__ + "img/Icon-Instagram.73252a02.svg";